export enum ApplicationApprovalStatus {
    Unknown = "Unknown",
    AwaitingApproval = "AwaitingApproval",
    Approved = "Approved",
    Rejected = "Rejected",
}
